<template>
  <div class="inline-filters" v-if="!isLoading">
    <div
      v-for="(filterOptions, filterKey, index) in availableFilters"
      :key="index"
    >
      <InlineFilter
        label="Booking ID"
        :filters="filters[filterKey]"
        @clear="handleClear(filterKey)"
        isText
      >
        <v-text-field
          type="number"
          min="0"
          aria-label="Booking ID"
          v-model="filters[filterKey]"
          @change="saveChanges"
          hide-details
        />
      </InlineFilter>
    </div>
  </div>
</template>

<script>
import { isEmpty, omitBy } from "lodash";
import InlineFilter from "@/components/common/InlineFilter";

export default {
  components: { InlineFilter },
  props: {
    isLoading: Boolean,
    availableFilters: Object,
    outerSelectedFilters: Object
  },
  data() {
    return {
      filters: Object.assign({}, this.outerSelectedFilters)
    };
  },
  methods: {
    saveChanges() {
      const formattedFilters = omitBy(this.filters, isEmpty);
      this.$emit("filter", formattedFilters);
    },
    updateFilterFor(key, value) {
      this.filters = { ...this.filters, [key]: value };
      this.saveChanges();
    },
    handleClear(key) {
      this.filters[key] = [];
      this.saveChanges();
    }
  },
  watch: {
    outerSelectedFilters(newValue) {
      if (isEmpty(newValue)) {
        this.filters = {};
      }
    }
  }
};
</script>
